import { EDeviceType, getThemeBreakpointByDeviceType } from "@utils/getThemeBreakpointByDeviceType";
import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()((theme) => ({
    footer: {
        flexShrink: 0,
        marginTop: "auto",
        backgroundColor: theme.palette.background.main,
    },
    box: {
        padding: theme.spacing(3, 2),
        maxWidth: 1280,
        margin: "0 auto",
        height: "100%",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            padding: theme.spacing(3),
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            alignItems: "stretch",
            justifyContent: "space-between",
        },
    },
    linkColumns: {
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            justifyContent: "center",
            gap: theme.spacing(3),
            "& > .MuiGrid-item": {
                flexBasis: "auto",
                flexGrow: 0,
                maxWidth: "none",
            },
        },
    },
    linksContainer: {
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "column",
        marginTop: theme.spacing(3),
        gap: theme.spacing(1),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE)]: {
            justifyContent: "center",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            justifyContent: "flex-start",
        },
        "& p, & a, & span": {
            marginTop: 0,
        },
        "& p": {
            lineHeight: 1.14,
        },
        "& span": {
            margin: theme.spacing(0, 1),
        },
        "& a": {
            "&:focus-visible": {
                outline: `2px solid ${theme.palette.secondary.main}`,
                outlineOffset: "2px",
                borderRadius: "4px",
            },
        },
    },
    brand: {
        display: "flex",
        gap: theme.spacing(1),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            justifyContent: "center",
            paddingTop: theme.spacing(5),
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            justifyContent: "flex-end",
            paddingTop: 0,
        },
    },
    brandIconButton: {
        width: 38,
        height: 38,
        padding: 0,
        "&:focus-visible": {
            outline: `2px solid ${theme.palette.secondary.main}!important`,
        },
    },
    brandIcon: {
        display: "inline-block",
        width: 18,
        height: 18,
        backgroundColor: theme.palette.secondary.main,
        maskRepeat: "no-repeat",
        maskPosition: "center",
        maskSize: "contain",
        WebkitMaskRepeat: "no-repeat",
        WebkitMaskPosition: "center",
        WebkitMaskSize: "contain",
    },
    brandSvgIcon: {
        display: "inline-block",
        width: 14,
        height: 14,
        "& path": {
            fill: theme.palette.secondary.main,
        },
    },
    bottom: {
        display: "flex",
        flexDirection: "column",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            alignItems: "center",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            alignItems: "flex-end",
            justifyContent: "flex-end",
        },
    },
    copyright: {
        display: "flex",
        paddingTop: theme.spacing(1.5),
        textTransform: "initial !important",
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            textAlign: "center",
            justifyContent: "center",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            textAlign: "left",
            justifyContent: "flex-end",
        },
    },
    cookie: {
        display: "flex",
        paddingTop: theme.spacing(2),
        [getThemeBreakpointByDeviceType(theme, EDeviceType.MOBILE_OR_TABLET)]: {
            justifyContent: "center",
        },
        [getThemeBreakpointByDeviceType(theme, EDeviceType.DESKTOP)]: {
            justifyContent: "flex-end",
        },
    },
}));
